/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Player-selected document category. Persisted to aid manual review; null for staff uploads.
 * @export
 */
export const PamDocumentType = {
    _11184809: '11184809',
    government_id: 'government_id',
    ssn_documentation: 'ssn_documentation',
    unknown_default_open_api: '11184809'
} as const;
export type PamDocumentType = typeof PamDocumentType[keyof typeof PamDocumentType];


export function instanceOfPamDocumentType(value: any): boolean {
    for (const key in PamDocumentType) {
        if (Object.prototype.hasOwnProperty.call(PamDocumentType, key)) {
            if (PamDocumentType[key as keyof typeof PamDocumentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PamDocumentTypeFromJSON(json: any): PamDocumentType {
    return PamDocumentTypeFromJSONTyped(json, false);
}

export function PamDocumentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDocumentType {
    return json as PamDocumentType;
}

export function PamDocumentTypeToJSON(value?: PamDocumentType | null): any {
    return value as any;
}

